import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import StockTransferListResults from 'components/StockTransfer/CustomerListResults';
import CustomerListToolbar from 'components/StockTransfer/CustomerListToolbar';
import { BaseUrl, endpoints } from '../utils/factory';
import axios from 'axios';
import moment from 'moment';
import { exportToExcel } from '../utils/exportToExcel';

const StockTransferList = () => {
  const [invoicelist, setInvoicelList] = useState([]);
  const [invoicelistOld, setInvoicelListOld] = useState([]);
  const [changeflag, setChangeFlag] = useState(false);
  const [bookedfilter, setBookedfilter] = useState(2);
  const [statusfilter, setStatusfilter] = useState(0);
  const [fromdate, setFromdate] = useState('');
  const [todate, setTodate] = useState('');
  const [loaderflag, setLoderFlag] = useState(false);
  const [exportflag, setExportFlag] = useState(true);
  const [exportflagver, setExportFlagVer2] = useState(true);
  const [exportflagverCSV, setExportFlagVerCsv] = useState(true);

  const [invoicelistexport, setInvoicelListExport] = useState([]);
  const [invoicelistexportver, setInvoicelListExportVer] = useState([]);
  const [invoicelistexportcsv, setInvoicelListExportCsv] = useState([]);

  const [searchtext, setSearchText] = useState('');

  const clientid = localStorage.getItem('trans-userId');
  const clientName = localStorage.getItem('trans-userName');
  const cmp_id = localStorage.getItem('trans-cmp_id');

  const handleExportData = async () => {
    setLoderFlag(true);
    try {
      const response = await axios.post(
        `${BaseUrl}trans_loaditems_stocktransfer`,
        {
          userid: clientid,
          qtype: '8',
          searchtext: bookedfilter,
          fdate: fromdate,
          tdate: todate,
        }
      );

      if (response.data && response.data.d && response.data.d.length > 0) {
        const userdata = JSON.parse(response.data.d); // Use JSON.parse instead of eval
        setInvoicelListExport(userdata);
      } else {
        setInvoicelListExport([]);
      }
      setExportFlag(false);
    } catch (error) {
      console.log('API error', error);
    } finally {
      setLoderFlag(false);
    }
  };

  const handlebetaversiontwo = async () => {
    console.log('In Export ver 2::::::::::::::');
    setLoderFlag(true);
    try {
      const response = await axios.post(
        `${BaseUrl}${endpoints.exportToExcel}/stock`,
        {
          userid: clientid,
          itono: searchtext,
          delfrom: fromdate,
          delto: todate,
          bookingSts: bookedfilter,
          qtype: '1',
          cmp_id: cmp_id,
          deliverycompany: clientid,
          itemStatusid: statusfilter
        }
      );

      if (Array.isArray(response.data) && response.data.length > 0 && typeof response.data[0] === 'object') {
        const userdata = response.data;
        setInvoicelListExportVer(userdata);
        exportToExcel(userdata, "Stock Transfer.xlsx", "Stock Transfer");
      } else {
        setInvoicelListExportVer([]);
      }
      
      setExportFlagVer2(false);
    } catch (error) {
      console.log('API error', error);
    } finally {
      setLoderFlag(false);
    }
  };

  const handleCsvButon = async () => {
    console.log('In Export ver 2::::::::::::::');
    setLoderFlag(true);
    try {
      const response = await axios.post(
        `${BaseUrl}tranexportcsv`,
        {
          userid: clientid,
          qtype: '1',
          status: bookedfilter,
          invoiceno: searchtext,
          fdate: fromdate,
          tdate: todate,
          invstatus: statusfilter,
        }
      );

      if (response.data && response.data.d && response.data.d.length > 0) {
        const userdata = JSON.parse(response.data.d); // Use JSON.parse instead of eval
        setInvoicelListExportCsv(userdata);
      } else {
        setInvoicelListExportCsv([]);
      }
      setExportFlagVerCsv(false);
    } catch (error) {
      console.log('API error', error);
    } finally {
      setLoderFlag(false);
    }
  };

  const handleResetFilter = () => {
    setBookedfilter(2);
    setStatusfilter(0);
  };

  const handleDate = async (fdate, sdate, bfilter) => {
    console.log('In date::::::::::::::1');
    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    const fdateformat = fdate ? moment.utc(fdate).format("YYYY-MM-DD") : moment.utc().format("YYYY-MM-DD");
    const sdateformat = sdate ? moment.utc(sdate).format("YYYY-MM-DD") : moment.utc().format("YYYY-MM-DD");

    setFromdate(fdateformat);
    setTodate(sdateformat);
    setBookedfilter(bfilter);

    if (fdateformat !== '' && sdateformat !== '') {
      setChangeFlag(true);
      setLoderFlag(true);
      setInvoicelList([]);
      setInvoicelListOld([]);
      const payload = {
        userid: clientid,
        qtype: '3',
        searchtext: "",
        Del_Datefrom: fdateformat,
        Del_Dateto: sdateformat,
        cmp_id: cmp_id,
        delsno: 0,
        username: clientName,
        bookingstatus: bfilter,
      };
      try {
        const response = await axios.post(
          `${BaseUrl}${endpoints.getOrdersStockTransfers}`,
          payload
        );

        if (response.data && response.data.length > 0) {
          const userdata = response.data;
          setInvoicelList(userdata);
          setInvoicelListOld(userdata);
        } else {
          setInvoicelList([]);
          setInvoicelListOld([]);
        }
      } catch (error) {
        console.error('API error', error);
      } finally {
        setLoderFlag(false);
      }
    }
  };

  const handlesearch = async (e, type) => {
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!33",);
    if (e.code === 'Enter' || type === '2') {
      if (type === '2' && e === '') {
        handleDate(fromdate, todate, bookedfilter);
        return;
      }
      if (type === '1' && e.target.value === '') return;
      setChangeFlag(true);
      setExportFlagVer2(true);
      setExportFlagVerCsv(true);
      setLoderFlag(true);
      handleResetFilter();

      try {
        setInvoicelList([]);
        setInvoicelListOld([]);

        const searchText = type === '1' ? e.target.value : e;

        const response = await axios.post(
          `${BaseUrl}${endpoints.getOrdersStockTransfers}`,
          {
            userid: clientid,
            qtype: '3',
            searchtext: searchText,
            Del_Datefrom: '',
            Del_Dateto: '',
            cmp_id: cmp_id,
            delsno: 0,
            username: clientName,
            bookingstatus: ''
          }
        );

        if (response.data && response.data.length > 0) {
          const userdata = response.data
          setInvoicelList(userdata);
          setInvoicelListOld(userdata);
        } else {
          setInvoicelList([]);
          setInvoicelListOld([]);
        }
      } catch (error) {
        console.log('API error', error);
      } finally {
        setLoderFlag(false);
      }
    }
  };

  const getchilddata = (data) => {
    setInvoicelList(data);
    setInvoicelListOld(data);
  };

  const handleChangeSelectSearch = (invoicestatus, bookedstatsus) => {
    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    let data = invoicelistOld;

    if (bookedstatsus === 0) {
      data = invoicelistOld.filter((id) => id.Itd_IsTransBooked === 'Pending');
    } else if (bookedstatsus === 1) {
      data = invoicelistOld.filter((id) => id.Itd_IsTransBooked === 'Booked');
    } else if (invoicestatus === 0 && bookedstatsus === 2) {
      data = invoicelistOld;
    }

    if (invoicestatus === 1) {
      data = data.filter((id) => id.Invoicestatus === 'Initiated');
    } else if (invoicestatus === 2) {
      data = data.filter((id) => id.Invoicestatus === 'Assign For Picking');
    } else if (invoicestatus === 3) {
      data = data.filter((id) => id.Invoicestatus === 'Picked');
    } else if (invoicestatus === 4) {
      data = data.filter((id) => id.Invoicestatus === 'Area Assign');
    } else if (invoicestatus === 5) {
      data = data.filter((id) => id.Invoicestatus === 'Ready for dispatch');
    } else if (invoicestatus === 0 && bookedstatsus === 2) {
      data = invoicelistOld;
    }

    setInvoicelList(data);
  };

  const handleChangeselect = (event) => {
    handleChangeSelectSearch(statusfilter, event.target.value);
    setBookedfilter(event.target.value);
  };

  useEffect(() => {
    const currentDate = new Date();
    const formattedCurrentDate = moment(currentDate).format('YYYY-MM-DD');

    // Optionally, set a date range (e.g., last 30 days)
    const prevDate = moment(currentDate).subtract(30, 'days').format('YYYY-MM-DD');

    setFromdate(prevDate);
    setTodate(formattedCurrentDate);
    handleDate(prevDate, formattedCurrentDate, '2');
  }, []);

  const handleSearchText = (inv) => {
    setSearchText(inv);
  };

  return (
    <>
      <Helmet>
        <title>Invoice List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <CustomerListToolbar
            clickToSearch={handlesearch}
            handleSearchText={handleSearchText}
            datesearch={handleDate}
            customers={invoicelist || []}
            handleChangeselect={handleChangeselect}
            selectvalue={bookedfilter}
            fromdate={fromdate}
            todate={todate}
            handleresetfilter={handleResetFilter}
          />
          <Box sx={{ pt: 3 }}>
            <StockTransferListResults
              customers={invoicelist || []}
              flagstatus={changeflag}
              getchilddata={getchilddata}
              fromdate={fromdate}
              todate={todate}
              datesearch={handleDate}
              bookedfilter={bookedfilter}
              loaderflag={loaderflag}
              exportlist={invoicelistexport}
              handleExportGrid={handleExportData}
              exportflag={exportflag}
              handleExportGridTwo={handlebetaversiontwo}
              exportlisttwo={invoicelistexportver}
              exportflagver={exportflagver}
              exportflagverCSV={exportflagverCSV}
              handelCsvButon={handleCsvButon}
              invoicelistexportcsv={invoicelistexportcsv}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default StockTransferList;
